<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.5 9L12.5 17L20.5 9" class="stroke-current" />
  </svg>
</template>
